import { Table, TableContainer, Tbody, Th, Thead, Typography } from '@aloft/toolkit-sui';

import { selectManufacturedCostApproachTableData } from '../../../redux/features/selectors/costApproachSelectors/selectManufacturedCostApproachTableData.ts';
import { useAppSelector } from '../../../redux/hooks.ts';
import { ManufacturedCostApproachTableRow } from './ManufacturedCostApproachTableRow.tsx';
import { ManufacturedCostApproachTableSectionRow } from './ManufacturedCostApproachTableSectionRow.tsx';

export function ManufacturedCostApproachTable() {
  const tableData = useAppSelector((state) =>
    selectManufacturedCostApproachTableData(state, 'subject'),
  );

  return (
    <TableContainer className="cost-approach-table">
      <Table>
        <Thead>
          <Th>
            <Typography variant="h4">{tableData.columnHeaders.left}</Typography>
          </Th>
          <Th>
            <Typography variant="h4">{tableData.columnHeaders.right}</Typography>
          </Th>
        </Thead>
        <Tbody>
          <ManufacturedCostApproachTableRow data={tableData.opinionOfSiteValue} bold />
          <ManufacturedCostApproachTableSectionRow data={tableData.sectionOne} />
          <ManufacturedCostApproachTableSectionRow data={tableData.sectionTwo} />
          <ManufacturedCostApproachTableSectionRow data={tableData.sectionThree} />
          <ManufacturedCostApproachTableSectionRow data={tableData.sectionFour} />
          {tableData.structures.map((structure) => (
            <ManufacturedCostApproachTableRow key={structure.label} data={structure} />
          ))}
          <ManufacturedCostApproachTableRow data={tableData.subTotal} bold />
          <ManufacturedCostApproachTableRow data={tableData.costMultiplier} />
          <ManufacturedCostApproachTableRow data={tableData.modifiedSubTotal} bold />
          <ManufacturedCostApproachTableRow data={tableData.physicalDepreciation} />
          <ManufacturedCostApproachTableRow data={tableData.functionalObsolescence} />
          <ManufacturedCostApproachTableRow data={tableData.externalDepreciation} />
          <ManufacturedCostApproachTableRow data={tableData.deliveryInstallationSetup} />
          <ManufacturedCostApproachTableRow data={tableData.otherDepreciatedImprovements} />
          <ManufacturedCostApproachTableRow data={tableData.marketValue} />
          <ManufacturedCostApproachTableRow data={tableData.indicatedValue} bold />
        </Tbody>
      </Table>
    </TableContainer>
  );
}
